import ReactCSSTransitionGroup from "react-addons-css-transition-group";

import BaseComponent from "../../baseComponent.js";
import CheckBox from "../../../components/common/check-box/checkBox.jsx"

import styles from './timeseries-config.scss';


export default class TimeSeriesCongifs extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      showConfigs: false
    }
  }

  onConfigChange(option, value) {
    this.props.onConfigChange(option, value);
  }

  onResolutionChange(resolution, value) {
    const resolutionsCopy = Object.assign({}, this.props.timeSeriesConfigs.resolutions);
    resolutionsCopy[resolution] = value;
    this.props.onConfigChange('resolutions', resolutionsCopy, false);
  }

  render() {
    const resolutionOptions = [
      ['1 second', '5 seconds', '15 seconds', '30 seconds'],
      ['1 minute', '5 minutes', '15 minutes', '30 minutes'],
      ['1 hour', '1 day', '1 week', '1 month', '1 year'],
    ];
    const configs = this.props.timeSeriesConfigs;
    return (
      <div className={styles.container}>
        <i className="icon-settings" onClick={e => this.setState({ showConfigs: !this.state.showConfigs })}></i>
        <ReactCSSTransitionGroup transitionName="example"
          transitionEnterTimeout={200}
          transitionLeaveTimeout={200}
          component="div">
          {this.state.showConfigs &&
            <div className={styles.configBox}>
              <i className={["material-icons", styles.closeIcon].join(" ")} onClick={e => this.setState({ showConfigs: false })}>close</i>
              <div className={styles.label}>Chart options</div>
              <div className={styles.otherConfigs}>
                <CheckBox value={configs.splitLeftRight} text="Separate Left Right Axis Data"
                  onChange={v => this.onConfigChange('splitLeftRight', v)} />
                <CheckBox value={configs.centerZeroLine} text="Center Zero Line"
                  onChange={v => this.onConfigChange('centerZeroLine', v)} />
                <CheckBox value={configs.autoAdjustWindowSize} text="Display All Data"
                  onChange={v => this.onConfigChange('autoAdjustWindowSize', v)} />
              </div>
              <div className={styles.label}>Resolution options</div>
              <div className={styles.resolutions}>
                {
                  resolutionOptions.map(group => <div>
                    {group.map(r => <div>
                      <CheckBox value={configs.resolutions[r]} text={r} onChange={v => this.onResolutionChange(r, v)} />
                    </div>)}
                  </div>)
                }
              </div>
            </div>}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/timeseriesConfigs.jsx